import { useAuthContext } from "../../../context/AuthContext";
import { useLanguageContext } from "../../../context/LanguageContext";
import useTerminalCreateRouteConfig from "../../../routes/configs/terminals/TerminalCreateRouteConfig";
import useTerminalEditRouteConfig from "../../../routes/configs/terminals/TerminalEditRouteConfig";
import DataTable, { useDataTable } from "../main/DataTable";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useBooleanColumnConfig from "../main/config/column/default/BooleanColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";

function TerminalsDataTable() {
  const { translate } = useLanguageContext();
  const authContext = useAuthContext();

  //Create the datatable config
  const config = new DataTableConfig("terminals");

  //Set the datatable fetch info
  config.setFetchRequest("terminals");
  config.setFetchParams({
    with_terminal_location_data: true,
    with_terminal_layout_data: true,
    with_terminal_printer_data: true,
    with_terminal_language_data: true,
    where: [
      { column: "company_id", values: [authContext.auth.user?.company?.id] },
    ],
  });

  //Set the datatable order by
  config.setOrderBy("name");
  config.setOrderDirection("asc");

  //Set the datatable columns
  config.setColumns([
    useBasicColumnConfig("location.name"),
    useBasicColumnConfig("name"),
    useBasicColumnConfig("layout.name"),
    useBasicColumnConfig("printer.name"),
    useBasicColumnConfig("language.label").setActive(false),
    useBooleanColumnConfig("show_sign_in_button").setActive(false),
    useBooleanColumnConfig("show_sign_out_button").setActive(false),
    useBooleanColumnConfig("show_qr_code_button").setActive(false),
    useBooleanColumnConfig("show_employee_registration_button").setActive(
      false,
    ),
    useBasicColumnConfig("status_after_sign_in.translation")
      .setActive(false)
      .setData((row) =>
        translate(`eva.main.visitor_statuses.${row.status_after_sign_in}`)
      ),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("terminal", useTerminalEditRouteConfig()),
    useDeleteRowActionConfig("terminal"),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig("terminal", useTerminalCreateRouteConfig()),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default TerminalsDataTable;
